import React, { InputHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

interface CheckboxProps
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    'type' | 'onChange' | 'size'
  > {
  label?: string;
  error?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  required?: boolean;
  size?: 'sm' | 'md';
}

const Checkbox: React.FC<CheckboxProps> = ({
  className,
  label,
  checked,
  onChange,
  error,
  required,
  disabled,
  size = 'md',
  ...props
}) => {
  const sizeClasses = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  const labelClasses = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <div className="space-y-1">
      <label
        className={cn(
          'flex items-center cursor-pointer',
          disabled && 'cursor-not-allowed opacity-50',
          className
        )}
      >
        <input
          type="checkbox"
          className={cn(
            'rounded border-border accent-primary focus:outline-none focus:ring-0 transition-colors',
            sizeClasses,
            error && 'border-destructive',
            disabled && 'cursor-not-allowed'
          )}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        {label && (
          <span className={cn('ml-2 text-foreground', labelClasses)}>
            {label}
            {required && <span className="text-destructive ml-1">*</span>}
          </span>
        )}
      </label>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};

export default Checkbox;
